export default __webpack_public_path__ + "static/media/usj.46fac733.png";